import * as Yup from "yup"
import { useFormik } from 'formik'
import { Link, useNavigate, useParams } from "react-router-dom"
import { createSelector } from "reselect"
import 'react-toastify/dist/ReactToastify.css'
import { withTranslation } from 'react-i18next'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from "react-redux"
import withRouter from '../../../components/Common/withRouter'
import Select from "react-select"
import makeAnimated from "react-select/animated"
import { Form, FormFeedback, Row, Col,Label, Input, Badge, Button } from 'reactstrap'
import {
    createRequisition as onCreateRequisition,
    getSubClassAccount as onGetSubClassAccount,
    getPaymentMode as onGetPaymentMode,
    getRequisition as onGetRequisition,
    updateRequisition as onUpdateRequisition,
} from "../../../slice/thunks"
import { useReactToPrint } from "react-to-print"
import logo from "../../../assets/images/HMS-Logo 1.png"

const CashCreateRequisition = (props) => {
    const {id, action} = useParams()
    const dispatch = useDispatch()
    const history = useNavigate()
    const animatedComponents = makeAnimated()
    const selectLayoutState = (state) => state.Settings;
    const SettingsProperties = createSelector(
      selectLayoutState,
      (setting) =>({
        requisition: setting.requisition,
        subClassAccount: setting.subClassAccount,
        paymentModes: setting.paymentModes,
        createRequisitionSuccess: setting.createRequisitionSuccess,
        updateRequisitionSuccess: setting.updateRequisitionSuccess,
        error: setting.error
      })
    )
    const {
        requisition,
        paymentModes,
        subClassAccount,
        createRequisitionSuccess,
        updateRequisitionSuccess,
        error
    } = useSelector(SettingsProperties)
    const [classAccountOption, setClassAccountOption] = useState(null)
    const [paymentModeOption, setPaymentModeOption] = useState(null)
    const [selectedClassAccount, setSelectedClassAccount] = useState(null)
    const [selectedPaymentMode, setSelectedPaymentMode] = useState(null)
    const [currentRequisition, setCurrentRequisition] = useState(null)
    const [netAmount, setNetAmount] = useState(0)
    const [ait, setAit] = useState(false)
    const [isView, setIsView] = useState(false)
    const [isEdit, setIsEdit] = useState(false)


    const loadRequesition = useCallback(() => {
        dispatch(onGetRequisition(id))
    })

    const loadPaymentMode = useCallback(() => {
        dispatch(onGetPaymentMode())
    })

    const loadClassAccount = useCallback(() => {
        dispatch(onGetSubClassAccount())
    })

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
    
        initialValues: {
            id: (currentRequisition && currentRequisition.id) || '',
            classAccountId: (currentRequisition && currentRequisition.classAccountId) || '',
            position: (currentRequisition && currentRequisition.position) || '',
            subject: (currentRequisition && currentRequisition.subject) || '',
            // amountInWord: (currentRequisition && currentRequisition.amountInWord) || '',
            beneficiary: (currentRequisition && currentRequisition.beneficiary) || '',
            tax: (currentRequisition && currentRequisition.tax) || '',
            amount: (currentRequisition && currentRequisition.amount) || '',
            paymentMode: (currentRequisition && currentRequisition.paymentMode) || '',
        },
    
        validationSchema: Yup.object({
            amount: Yup.string().required(props.t("you_need_provide_amount")),
            beneficiary: Yup.string().required(props.t("you_need_provide_beneficiary")),
            position: Yup.string().required(props.t("you_need_provide_position")),
        }),
    
        onSubmit: (values) => {
    
            if (action && action =='edit') {
                const updateForm = {
                    position: values.position,
                    subject: values.subject,
                    // amountInWord: values.amountInWord,
                    classAccountId: selectedClassAccount && selectedClassAccount.value,
                    paymentMode: selectedPaymentMode && selectedPaymentMode.value,
                    beneficiary: values.beneficiary,
                    tax: ait ? 5.5 : 0,
                    amount: values.amount
                }
                const id = currentRequisition.id
                dispatch(onUpdateRequisition({ body: updateForm, id: id }))
    
            } else {
                const newForm = {
                    position: values.position,
                    subject: values.subject,
                    // amountInWord: values.amountInWord,
                    classAccountId: selectedClassAccount && selectedClassAccount.value,
                    paymentMode: selectedPaymentMode && selectedPaymentMode.value,
                    beneficiary: values.beneficiary,
                    tax: ait ? 5.5 : 0,
                    amount: values.amount
                }
    
                dispatch(onCreateRequisition(newForm))
            }
        },
    
    })

    useEffect(() => {
        loadPaymentMode()
        loadClassAccount()
    },[dispatch])

    useEffect(() => {
        if (paymentModes && paymentModes.length > 0) {
            const payment_lists = paymentModes.filter(mode => mode.value !== 'PATIENT_CREDIT').map(mode => ({
                label: mode.title,
                value: mode.value
            }));
            setPaymentModeOption(payment_lists);
        }
    }, [paymentModes]);

    useEffect(() =>{
        if (subClassAccount && subClassAccount.length > 0) {
          const subClassAccount_list = subClassAccount.map( subclass => {
            return { label: subclass.name, value: subclass.id }
          })
          setClassAccountOption(subClassAccount_list)
        }
    },[subClassAccount])

    useEffect(() =>{
        if (createRequisitionSuccess && !error) {
          validation.resetForm()
          history("/cashier/requisitions")
        }
    },[createRequisitionSuccess, error, requisition])

    useEffect(() =>{
        if (updateRequisitionSuccess && !error) {
          validation.resetForm()
          history("/cashier/requisitions")
        }
    },[updateRequisitionSuccess, error, requisition])

    useEffect(() =>{
        if (id) {
            loadRequesition()
        }
    },[id])

    useEffect(() => {
        if(action === "view") {
            setIsView(true)
        } else if(action === "edit") {
            setIsEdit(true)
        }
    },[action])

    useEffect(() => {
        
        if (id && (requisition && requisition.id)) {
            setCurrentRequisition(requisition)
            setAit(requisition.tax > 0 ? true : false)
            setSelectedClassAccount(requisition.classAccountId && (classAccountOption != null) ? classAccountOption.find((element) => element.value === requisition.classAccountId) : null)
            setSelectedPaymentMode(requisition.paymentMode && (paymentModeOption != null) ? paymentModeOption.find((element) => element.value === requisition.paymentMode) : null )
        }
    },[requisition, paymentModeOption, classAccountOption])

    useEffect(() => {
        if (validation.values.amount > 0 && ait) {
            setNetAmount((parseInt(validation.values.amount)+(validation.values.amount*5.5)/100))
        } else {
            setNetAmount(validation.values.amount)
        }
    },[validation.values.amount, ait])


         const componentRef = useRef()
    
        const handlePrint = useReactToPrint({
          content: () => componentRef.current,
        })
    


return (
    <div className="dashboard">
        {/* <!-- Start requisition Section --> */}
        <div className="budgeting-sec">
            <div className="container pt-4">
                <div className="heading-parent-sec">
                    <div className="heading-child-one-sec d-flex gap-2">
                     <div onClick={()=>history(-1)} className="py-2" style={{cursor:"pointer"}}>
                        <i class="fa-solid fa-arrow-left fs-3"></i>
                     </div>
                        <h6 className="m-0 p-0">{action && action =='edit' ? props.t("edit_requisition") : action && action =='view' ? 'Requisitions Payment Details' : props.t("create_requisition")}</h6>
                    </div>
                    <div className="heading-child-two-sec">
                    </div>
                </div>

             <div>
                   <div className="card p-5"
                    style={{ borderRadius: "10px", border: "transparent", boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)", height: "500px" }}>

                      {isView && (
                        <>
                          <Row className="border p-2 rounded-2">
                            <Col>
                                <b>Beneficairy Name</b>
                                <h4>{requisition?.beneficiary}</h4>
                                <p>Position: {requisition?.position}</p>
                            </Col>
                            <Col className="d-flex flex-column">
                                <b>Amount</b>
                                <h4>{requisition?.amount || 0} XAF</h4>
                                {requisition?.amountInWord && <b>(in words): {requisition?.amountInWord}</b>}
                                <b className="text-danger">AIT: {requisition?.tax}</b>
                            </Col>
                            <Col className="d-flex flex-column">
                                <b>Status:</b>
                                <Badge color="success"><h5>{requisition?.status}</h5></Badge>
                            </Col>
                        </Row>

                        <Row className="mt-4">
                            <Col>
                                <b>subject</b>
                                <p className="fw-normal">{requisition?.subject}</p>
                            </Col>
                            <Col>
                                <b>requisition Ref</b>
                                <h6 className="fw-normal">{requisition?.requisitionRef}</h6>
                            </Col>
                            <Col>
                                <b>Class Account</b>
                                <h6 className="fw-normal">{requisition?.classAccountName}</h6>
                            </Col>
                        </Row>

                        <Row className="mt-4">
                            <Col>
                                <b>Payment Mode</b>
                                <h6 className="fw-normal">{requisition?.paymentMode}</h6>
                            </Col>
                            <Col>
                                <b>Paid By</b>
                                <h6 className="fw-normal">{requisition?.paidBy}</h6>
                            </Col>
                            <Col>
                                <b>Approved By</b>
                                <h6 className="fw-normal">{requisition?.approvedBy}</h6>
                            </Col>
                        </Row>
                        </>
                        
                      )}
                       
                    
                {(isEdit || !isView) && (
                    <>
                        <div className="row d-flex justify-content-between">
                        <Form className="tablelist-form" autoComplete="off" onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}>
                        
                            <div className="filter1 d-flex align-items-center">
                                
                                <Col xl={6} sm={6}>
                                    <div className="mb-3">
                                    <Label
                                        htmlFor="wards-field"
                                        className="form-label"
                                    >
                                        {props.t("choose_class")}
                                    </Label>
                                    <Select
                                        name='accountType'
                                        id='accountType-field'
                                        value={selectedClassAccount}
                                        isMulti={false}
                                        isClearable={true}
                                        autoComplete="off" 
                                        // className='p-0'
                                        onBlur={validation.handleBlur}
                                        onChange={(e) => {
                                            setSelectedClassAccount(e);
                                        }}
                                        options={classAccountOption}
                                        closeMenuOnSelect={true}
                                        components={animatedComponents}
                                        isDisabled= { isView ? true : false }
                                    />
                                    </div>
                                </Col>
                            </div>

                            <Row className="row px-4 py-4">
                                <Col xl={6} sm={6}>
                                    <label htmlFor="">{props.t("amount")}<span className='text-danger'>*</span></label>
                                    <Input 
                                        className="p-3" 
                                        type="number" 
                                        id="amount" 
                                        name="amount"
                                        placeholder=""
                                        style={{ border: "1px solid #D0D0D0", width: "-webkit-fill-available", height: "50px", borderRadius: "10px" }}
                                        validate={{
                                            required: { value: true },
                                        }}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.amount || ""}
                                        invalid={
                                            validation.touched.amount && validation.errors.amount ? true : false
                                        }
                                        disabled= { isView ? true : false }
                                    />
                                    {validation.touched.amount && validation.errors.amount ? (
                                        <FormFeedback type="invalid">{validation.errors.amount}</FormFeedback>
                                    ) : null}
                                </Col>
                                {/* <Col  xl={6} sm={6}>
                                    <label htmlFor="">{props.t("in_words")}</label>
                                    <Input 
                                        className="p-3" 
                                        type="text" 
                                        id="amountInWords" 
                                        name="amountInWord"
                                        placeholder=""
                                        style={{ border: "1px solid #D0D0D0", width: "-webkit-fill-available", height: "50px", borderRadius: "10px" }}
                                        validate={{
                                            required: { value: true },
                                        }}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.amountInWord || ""}
                                        invalid={
                                            validation.touched.amountInWord && validation.errors.amountInWord ? true : false
                                        }
                                        disabled= { isView ? true : false }
                                    />
                                    {validation.touched.amountInWord && validation.errors.amountInWord ? (
                                        <FormFeedback type="invalid">{validation.errors.amountInWord}</FormFeedback>
                                    ) : null}
                                </Col> */}
                                <Col  xl={6} sm={6}>
                                    <label htmlFor="">{props.t("beneficiary")}<span className='text-danger'>*</span></label>
                                    <Input 
                                        className="p-3" 
                                        type="text" 
                                        id="to" 
                                        name="beneficiary"
                                        placeholder=""
                                        style={{ border: "1px solid #D0D0D0", width: "-webkit-fill-available", height: "50px", borderRadius: "10px" }}
                                        validate={{
                                            required: { value: true },
                                        }}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.beneficiary || ""}
                                        invalid={
                                            validation.touched.beneficiary && validation.errors.beneficiary ? true : false
                                        }
                                        disabled= { isView ? true : false }
                                    />
                                    {validation.touched.beneficiary && validation.errors.beneficiary ? (
                                        <FormFeedback type="invalid">{validation.errors.beneficiary}</FormFeedback>
                                    ) : null}
                                </Col>
                                <Col  xl={6} sm={6}>
                                    <label htmlFor="">{props.t("position")}<span className='text-danger'>*</span></label>
                                    <Input 
                                        className="p-3" 
                                        type="text" 
                                        id="position" 
                                        name="position"
                                        placeholder=""
                                        style={{ border: "1px solid #D0D0D0", width: "-webkit-fill-available", height: "50px", borderRadius: "10px" }}
                                        validate={{
                                            required: { value: true },
                                        }}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.position || ""}
                                        invalid={
                                            validation.touched.position && validation.errors.position ? true : false
                                        }
                                        disabled= { isView ? true : false }
                                    />
                                    {validation.touched.position && validation.errors.position ? (
                                        <FormFeedback type="invalid">{validation.errors.position}</FormFeedback>
                                    ) : null}
                                </Col>

                                <Col  xl={6} sm={6}>
                                    <label htmlFor="">{props.t("subject")}<span className='text-danger'>*</span></label>
                                    <Input 
                                        className="p-3" 
                                        type="textarea" 
                                        id="justification" 
                                        name="subject"
                                        rows="3"
                                        placeholder=""
                                        style={{ border: "1px solid #D0D0D0", width: "-webkit-fill-available", height: "50px", borderRadius: "10px", resize: "none" }}
                                        validate={{
                                            required: { value: true },
                                        }}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.subject || ""}
                                        invalid={
                                            validation.touched.subject && validation.errors.subject ? true : false
                                        }
                                        disabled= { isView ? true : false }
                                    />
                                    {validation.touched.subject && validation.errors.subject ? (
                                        <FormFeedback type="invalid">{validation.errors.subject}</FormFeedback>
                                    ) : null}
                                </Col>
                                <Col xl={6} sm={6} className="p-4">
                                        <span className="pt-3 mt-4" style={{ fontSize: "18px", color: "rgb(3, 197, 3)", fontWeight: "600", paddingRight: "10px" }} >{props.t("bill_amount")}: </span>
                                        <span style={{ color: "rgb(3, 197, 3)", fontSize: "18px" }}>&nbsp;{validation.values.amount}</span>
                                        &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp;
                                        <span className="pt-3 mt-4" style={{ fontSize: "18px", color: "rgb(0, 0, 0)", fontWeight: "600", paddingRight: "34px" }} >{props.t("net_amount")}: </span>
                                        <span style={{ color: "rgb(0, 0, 0)", fontSize: "18px" }}>&nbsp;{netAmount}</span>
                                        <br />
                                        <Input 
                                            className="form-check-input mx-1" 
                                            type="checkbox" 
                                            checked= {ait}
                                            id="flexCheckDefault" 
                                            onChange={() => {
                                                setAit(!ait);
                                            }}
                                        /> 
                                        <span className="pt-3 mt-4" style={{ fontSize: "18px", color: "rgb(197, 3, 3)", fontWeight: "600", paddingRight: "85px" }} >
                                            {props.t("ait")}: 
                                        </span>
                                        <span style={{ color: "orange", fontSize: "18px" }}>&nbsp;5.5 %</span>
                                </Col>
                            </Row>

                            <div className="row px-4 py-3 justify-content-end" style={{ gap: "30px" }}>
                                <div className="col-lg-6 text-end" style={{ gap: "30px" }}>
                                    { isView ?
                                        <></>
                                        :
                                        <button 
                                            type="submit" 
                                            className="btn btn-success"
                                        >
                                            {props.t("forward_for_approval") }
                                        </button>
                                    }
                                    <Link 
                                        type="button"
                                        className="btn btn-outline ms-2"
                                        to="/accounting/requisitions"
                                        style={{ border: "1px solid #00000080", padding: "5px 22px" }}
                                    >
                                        {props.t("cancel")}
                                    </Link>
                                </div>
                            </div>
                        </Form>
                    </div>
                    </>
                )}
                </div>

                {/* Receipt  Section*/}
             <div>
                <div className="p-2 card mt-2">
<div className="p-2 d-none d-print-block" ref={componentRef} >
    <div className="text-center">
    <img src={logo} alt="logo" width={200} />
</div>
   <div className='text-center d-flex flex-column gap-1 align-items-center'>
  <h4 className='fw-bold text-danger'>BIAKA HOSPITAL</h4>
  <h5 className='text-success'>BOKOKO-BUEA</h5>
  <div className='d-flex  gap-5'>
    <p>Email:biakahospital@biakahc.org</p>
    <p>Phone: (+237) 233 322 558 / 698 625 760</p>
  </div>
</div>
<hr />
<div className="d-flex justify-content-between align-items-center">
    <h4 className="fw-bold">PETTY CASH PAYMENT RECEIPT</h4>
 <div className="d-flex flex-column w-25">
       <p className="mb-1">Receipt No: {currentRequisition && currentRequisition.requisitionRef}</p>
       <hr className="my-1"/>
    <p className="mb-1">Receipt Date: {currentRequisition && currentRequisition.createdAt.toString().split("T")[0]}</p>
    <p className="mb-1">Status: <Badge color="success" className="p-2">{currentRequisition && currentRequisition.status}</Badge></p>
 </div>
</div>
<hr />
<div className="px-3">
    <Row className="border py-3 mb-3 rounded-1 align-items-center">
        <Col>
            <p className="fs-5 mb-0">Pay in cash following this requisition the Amount of:</p>
        </Col>
        <Col>
            <h4 className="fw-bold mb-0">{currentRequisition && `${currentRequisition.amount} FCFA`}</h4>
        </Col>
    </Row>
  {
      currentRequisition?.amountInWords && <Row>
        <Col>
            <h5>(In Words):</h5>
        </Col>
        <Col>
            <h5 className="fw-bold mb-0">{currentRequisition && currentRequisition.amountInWords}</h5>
        </Col>
    </Row>
  }
    <Row className="align-items-center">
        <Col className="d-flex align-items-center gap-2">
            <h6 className="fw-bold fs-5 pb-2">To:</h6>
            <p className="fs-5">{currentRequisition && currentRequisition.beneficiary}</p>
        </Col>
        <Col className="d-flex align-items-center gap-2">
            <h6 className="fw-bold fs-5 mb-0">Positions:</h6>
            <p className="fs-5 mb-0">{currentRequisition && currentRequisition.position}</p>
        </Col>
    </Row>
    <Row className="align-items-center">
        <Col className="d-flex align-items-center gap-2">
            <h6 className="fw-bold fs-5 pb-2 mb-0">Subject:</h6>
            <p className="fs-5 mb-0">{currentRequisition && currentRequisition.subject}</p>
        </Col>
        <Col className="d-flex align-items-center gap-2">
            <h6 className="fw-bold fs-5 pb-2 mb-0">Tax:</h6>
            <p className="fs-5 mb-0">{currentRequisition && currentRequisition.tax}</p>
        </Col>
    </Row>
    <h6 className="fw-bold fs-5 mb-0 mt-3">Payment Details</h6>
    <hr className="my-0"/>
    <Row className="mt-2">
        <Col className="d-flex align-items-center gap-2">
            <h6 className="fw-bold fs-5 pb-2">Payment Mode:</h6>
            <p className="fs-5">{currentRequisition && currentRequisition.paymentMode}</p>
        </Col>
        <Col className="d-flex align-items-center gap-2">
            <h6 className="fw-bold fs-5 pb-2">Paid By:</h6>
            <p className="fs-5">{currentRequisition && currentRequisition.paidBy}</p>
        </Col>
    </Row>
    <Row className="mt-2">
        <Col className="d-flex align-items-center gap-2">
            <h6 className="fw-bold fs-5 pb-2">Approved By:</h6>
            <p className="fs-5">{currentRequisition && currentRequisition.approvedBy}</p>
        </Col>

    </Row>
</div>
</div>

                </div>
                  {/* <div ref={componentRef} className="px-4 py-2">
                 <h4>
                    payments receipt
                </h4>
                <div className="card px-2 py-2">
                    <Row className="d-flex justify-content-between">
                        <Col className="d-flex justify-content-between">
                        <b>Receipt No: {currentRequisition && currentRequisition.requisitionRef}</b>
                        <b>Receipt Date: {currentRequisition && currentRequisition.createdAt.toString().split("T")[0]}</b>
                        <b>Status: <Badge color="success" className="p-2">{currentRequisition && currentRequisition.status}</Badge></b>
                        </Col>
                    </Row>
                    <hr />
                    <div className="d-flex justify-content-between align-items-center">
                        <div><Row>
                        <Col className="font-weight-bold">
                            <h5><b>beneficiary: {currentRequisition && currentRequisition.beneficiary}</b></h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>subject:</b> {currentRequisition && currentRequisition.subject}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>position:</b> {currentRequisition && currentRequisition.position}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>amount:</b> {currentRequisition && currentRequisition.amount}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>amountInWord:</b> {currentRequisition && currentRequisition.amountInWord}
                        </Col>
                    </Row>
                    </div>
                    <div>
                        <Row>
                        <Col>
                            <b>tax:</b> {currentRequisition && currentRequisition.tax}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>approvedBy:</b> {currentRequisition && currentRequisition.approvedBy}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>paidBy:</b> {currentRequisition && currentRequisition.paidBy}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>paymentMode:</b> {currentRequisition && currentRequisition.paymentMode}
                        </Col>
                    </Row>
                    </div>
                    </div>
                    
                </div>
               </div> */}
             <div className="text-end">
                  <Button     color="primary"
                            type="button"
                            className="btn btn-primary mt-3"
                            onClick={() => {
                                handlePrint()
                            }}>
                <i className="fa-solid fa-print"></i>
                {props.t("Print")}
                </Button>
             </div>
             </div>

             </div>
            </div>
            {/* <!-- Dashboard-cards End --> */}
        </div>
        {/* <!-- banking End --> */}
    </div>
  )
}

export default withRouter(withTranslation()(CashCreateRequisition))
